module.exports = __webpack_public_path__ + "static/media/wireframe-box.69afef8a.png";